export default function AboutPage() {
    return (
        <div className="about-page" data-testid="about-page">
            <div className="page-header">
                <h1>About Us</h1>
                <p>Your trusted partner in financial solutions</p>
            </div>

            <div className="container">
                <div className="about-content-page">
                    <section className="about-intro">
                        <h2>Who We Are</h2>
                        <p>
                            Laxmi Finsec Consultant Pvt. Ltd. is a leading financial services provider dedicated to offering comprehensive
                            loan solutions tailored to meet diverse financial needs. With over 10 years of industry experience, we
                            have established ourselves as a trusted partner for individuals and businesses seeking reliable financial assistance.
                        </p>
                    </section>

                    <section className="about-mission">
                        <h2>Our Mission</h2>
                        <p>
                            Our mission is to provide accessible, transparent, and customer-centric financial services that empower
                            individuals and businesses to achieve their goals. We believe in fair dealing and prompt disbursement of
                            funds on a priority basis, ensuring that our clients receive the support they need when they need it most.
                        </p>
                    </section>

                    <section className="about-services-list">
                        <h2>Our Services</h2>
                        <p>We offer a comprehensive range of loan products designed to meet various financial requirements:</p>
                        <ul>
                            <li>Women Group Loan</li>
                            <li>Personal Loan</li>
                            <li>Education Loan</li>
                            <li>Home Loan</li>
                            <li>Business Loan</li>
                            <li>Agriculture Loan</li>
                            <li>Property Loan</li>
                            <li>Shop Loan</li>
                            <li>Flat Loan</li>
                            <li>And many more...</li>
                        </ul>
                    </section>

                    <section className="about-why">
                        <h2>Why Choose Us</h2>
                        <div className="why-grid">
                            <div className="why-item">
                                <h3>Experienced Team</h3>
                                <p>Our team of 1360+ professionals brings extensive industry knowledge and expertise.</p>
                            </div>
                            <div className="why-item">
                                <h3>Customer Satisfaction</h3>
                                <p>With 8560+ happy clients, we have a proven track record of delivering excellent service.</p>
                            </div>
                            <div className="why-item">
                                <h3>Quick Processing</h3>
                                <p>We ensure fast and efficient loan processing to meet your urgent financial needs.</p>
                            </div>
                            <div className="why-item">
                                <h3>Transparent Dealings</h3>
                                <p>We believe in complete transparency with no hidden charges or fees.</p>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
};